import {ClientHostConsumerBase} from '../../ClientHost/ClientHostConsumerBase';
import { Utils, CommonTypes} from 'neo-common';
import {ClientHostDispatchExitRequest} from '../../ClientHost/Types';
import {IApp} from '../IApp';
import {IBalance} from '../../Communication/Game/Types/IBalance';


export abstract class GameClientHostConsumerBase extends ClientHostConsumerBase {
    //private _exitGameFunc: any;

    constructor(app: IApp) {
        super(app);
    }

    /**
     * Handle exit from client host
     * @param callback - function needs to be called when game finished its exit to notify client host about completed exit routine.
     */
    handleExit(request: ClientHostDispatchExitRequest, callback: CommonTypes.ErrorFunction): void {
        if (DEBUG) {
            console.log(`GameClientHostConsumerBase, Received "handleExit" event, request: ${JSON.stringify(request)}'`);
        }

        let gameCollect = Utils.valueOrDefault(request.GameCollect, true);

        if (DEBUG) {
            console.log(`GameClientHostConsumerBase, handleExit -> gameCollect = ${gameCollect}`);
        }

        let canExitNow = !gameCollect || this.terminateOnCollect();

        if (DEBUG) {
            console.log(`GameClientHostConsumerBase, canExitNow: ${canExitNow}`);
        }

        if (canExitNow) {
            this._app.exit();
        }
    }

    /**
     * This is called when client host request exit of game.
     * Method should return: true - when game is not active and game can be exited immediately (by client host).
     * false - when there is active (unfinished) game and client host must not exist game immediately (by client host),
     * it will be exited manually by game itself (calling @GameAppBase.exit())
     */
    abstract terminateOnCollect(): boolean;

    /**
     * Handle update to account balance.
     * @param {IBalance} balance
     */
    abstract handleAccountUpdate(balance: IBalance, forceShow: boolean): void;
}



/** WEBPACK FOOTER **
 ** ./Engine/GameEngine/Game/GameClientHostConsumerBase.ts
 **/